import { all, call, put, take, takeEvery } from "redux-saga/effects";

import { createError } from "core/exceptions";
import log from "loglevel";
import { actions, ASSET_STATUS } from "./actions";
import { createUploadFileChannel } from "./sagasHelpers";

export function* uploadFileSaga(assetFile) {
    try {
        const id = assetFile.file.id;
        const file = assetFile.file;
        const channel = yield call(createUploadFileChannel, assetFile.url, file);
        while (true) {
            let { progress, err, success } = yield take(channel);
            progress = progress || 0;
            if (err) {
                yield put(actions.UPDATE_ASSET_STATUS.call({ id, status: ASSET_STATUS.FAILED_UPLOAD }));
                return;
            }
            if (success) {
                yield put(actions.UPDATE_ASSET_STATUS.call({ id, status: ASSET_STATUS.UPLOADED }));
                return;
            }
            yield put(actions.UPDATE_ASSET_PROGRESS.call({ id, progress }));
        }
    } catch (error) {
        log.error(error);
    }
}

function createFileAssetObj(files, url) {
    const result = [];
    files.map((file) => {
        result.push({
            url,
            file,
        });
    });
    return result;
}

export function* uploadFiles({ payload }) {
    try {
        const { files, url } = payload;
        const fileAssets = createFileAssetObj(files, url);
        const calls = [];
        const ids = [];
        fileAssets.forEach((fileAsset) => {
            // eslint-disable-next-line redux-saga/yield-effects
            const callElement = call(uploadFileSaga, fileAsset);
            ids.push(fileAsset.file.id);
            calls.push(callElement);
        });
        yield all(calls);
        yield put(actions.UPLOAD_BATCH_ASSETS.success({ ids }));
    } catch (e) {
        log.error(e);
        const error = createError(e);
        yield put(actions.UPLOAD_BATCH_ASSETS.failed(error));
    }
}

const sagas = [takeEvery(actions.UPLOAD_BATCH_ASSETS.sendType, uploadFiles)];
export default sagas;
